<template>
  <hr :class="$style.separator" />
</template>

<script>
export default {
  name: "fragment-separator"
};
</script>

<style module lang="scss">
@import "../../style/abstract/abstract.colors";
@import "../../style/abstract/abstract.functions";
@import "../../style/abstract/abstract.spacing";

.separator {
  height: rem-calc(1);
  border: none;
  color: $color-silver;
  margin: rem-calc($spacing-xl) 0;
  background-color: $color-silver;
}
</style>
